"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Arduino(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M18.157 6C21.379 6 24 8.538 24 11.658c0 3.111-2.607 5.643-5.816 5.658a8.1 8.1 0 0 1-.346.008c-1.534 0-2.844-.517-3.997-1.574-.713-.653-1.3-1.452-1.841-2.285-.54.833-1.128 1.632-1.841 2.285-1.239 1.136-2.66 1.648-4.343 1.566C2.606 17.301 0 14.769 0 11.658 0 8.538 2.621 6 5.843 6c1.762 0 3.247.583 4.537 1.783.62.576 1.142 1.245 1.62 1.944.477-.699 1-1.368 1.62-1.944C14.91 6.583 16.394 6 18.157 6zm0 1.997c-1.252 0-2.262.396-3.177 1.248-.684.637-1.249 1.452-1.806 2.337.639 1.038 1.259 2.003 2.015 2.696.854.781 1.753 1.103 2.915 1.042l.053-.001c2.121 0 3.846-1.643 3.846-3.661 0-2.02-1.725-3.661-3.846-3.661zm-12.314 0c-2.122 0-3.846 1.641-3.846 3.661 0 2.018 1.724 3.661 3.846 3.661l.052.001c1.162.061 2.062-.261 2.915-1.042.756-.693 1.377-1.658 2.016-2.696-.558-.885-1.122-1.7-1.807-2.337-.915-.852-1.925-1.248-3.176-1.248zm13.662 2.934v1.122h-1.083v1.091h-1.127v-1.09h-1.083V10.93h1.083V9.85h1.127v1.082h1.083zM4.22 12.075H7.78V10.92H4.22v1.156z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Arduino;
